import React, { useCallback } from 'react'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import { AddButton, SearchInput, useAction, useHelmet } from '@agro-club/frontend-shared'
import BadgeList from './BadgeList'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import Routes from '../routes'
import BadgeActions from 'modules/domain/badge/duck'
import BadgeSelectors from 'modules/domain/badge/selectors'
import { useSelector } from 'react-redux'

const SearchInputWrapper = styled.div`
  margin-top: 14px;
  margin-bottom: 4px;
  width: 50%;
`

const BadgeTable = () => {
  const filter = useSelector(BadgeSelectors.filter)
  const filterUpdated = useAction(BadgeActions.filterUpdated)
  const { t } = useTranslation('badge')

  const handleSearchChange = useCallback(
    (search?: string) => {
      filterUpdated({ ...filter, ...{ search } })
    },
    [filterUpdated, filter],
  )

  useHelmet({ title: t('badgesMetaTitle') })

  return (
    <>
      <Layout.Header>
        <Header.Root>
          <Header.Title title={t('list.heading')}>
            <AddButton to={Routes.Add} />
          </Header.Title>
          <SearchInputWrapper>
            <SearchInput
              onChange={handleSearchChange}
              value={filter.search}
              placeholder={t('list.searchPlaceholder')}
            />
          </SearchInputWrapper>
        </Header.Root>
      </Layout.Header>
      <Layout.Content>
        <BadgeList />
      </Layout.Content>
    </>
  )
}

export default BadgeTable
